<template>
  <Mk-Table></Mk-Table>
</template>

<script>
import MkTable from "../components/MkTable.vue";

export default {
  components: {
    MkTable,
  },
};
</script>